import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

// Public pages
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Apply from "@/pages/Apply";

// Client portal
import ClientDashboard from "@/pages/client/Dashboard";
import MyApplications from "@/pages/client/MyApplications";
import MyLoans from "@/pages/client/MyLoans";
import LoanDetail from "@/pages/client/LoanDetail";

// Admin
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminApplications from "@/pages/admin/Applications";
import AdminApplicationDetail from "@/pages/admin/ApplicationDetail";
import AdminCustomers from "@/pages/admin/Customers";
import AdminCustomerDetail from "@/pages/admin/CustomerDetail";
import AdminLoans from "@/pages/admin/Loans";
import AdminLoanDetail from "@/pages/admin/LoanDetailAdmin";
import AdminMessages from "@/pages/admin/Messages";
import AdminNotifications from "@/pages/admin/Notifications";
import AdminArrears from "@/pages/admin/Arrears";
import AdminAudit from "@/pages/admin/Audit";

function HomeRedirect() {
  // After login pages can navigate here based on role
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/apply" element={<Apply />} />

            {/* Client */}
            <Route path="/dashboard" element={<ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/applications" element={<ProtectedRoute role="client"><MyApplications /></ProtectedRoute>} />
            <Route path="/dashboard/loans" element={<ProtectedRoute role="client"><MyLoans /></ProtectedRoute>} />
            <Route path="/dashboard/loans/:id" element={<ProtectedRoute role="client"><LoanDetail /></ProtectedRoute>} />

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/applications" element={<ProtectedRoute role="admin"><AdminApplications /></ProtectedRoute>} />
            <Route path="/admin/applications/:id" element={<ProtectedRoute role="admin"><AdminApplicationDetail /></ProtectedRoute>} />
            <Route path="/admin/customers" element={<ProtectedRoute role="admin"><AdminCustomers /></ProtectedRoute>} />
            <Route path="/admin/customers/:id" element={<ProtectedRoute role="admin"><AdminCustomerDetail /></ProtectedRoute>} />
            <Route path="/admin/loans" element={<ProtectedRoute role="admin"><AdminLoans /></ProtectedRoute>} />
            <Route path="/admin/loans/:id" element={<ProtectedRoute role="admin"><AdminLoanDetail /></ProtectedRoute>} />
            <Route path="/admin/messages" element={<ProtectedRoute role="admin"><AdminMessages /></ProtectedRoute>} />
            <Route path="/admin/notifications" element={<ProtectedRoute role="admin"><AdminNotifications /></ProtectedRoute>} />
            <Route path="/admin/arrears" element={<ProtectedRoute role="admin"><AdminArrears /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute role="admin"><AdminAudit /></ProtectedRoute>} />

            <Route path="*" element={<HomeRedirect />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
